export const DEFAULT_DEALER_URL = '/home';
export const DEFAULT_SUBDIVISION_USER_URL = '/work-rules';